<template>
  <div class="mine-page">
    <!-- ========== 头部区域 ========== -->
    <div class="header-section">
      <!-- 顶部标题 -->
      <div class="header-bar">
        <span class="header-title">我的</span>
      </div>

      <!-- 用户信息 -->
      <div class="profile-area">
        <div class="avatar-big">
          <div class="avatar-border">
            <img :src="userAvatar" alt="" />
          </div>
          <div class="avatar-badge">
            <nut-icon name="checklist" size="10" color="#fff"></nut-icon>
          </div>
        </div>
        <h2 class="profile-name">{{ userName }}</h2>
        <p class="profile-role">{{ userDept }}</p>
      </div>
    </div>

    <!-- ========== 内容区域 ========== -->
    <div class="content-section">
      <!-- 账户管理 -->
      <div class="section-group">
        <div class="menu-card">
          <div class="menu-item" @click="handleNavigate('password')">
            <div class="menu-icon-box icon-eye">
              <!-- <nut-icon name="eye" size="17" color="#8B7355"></nut-icon> -->
			  <svg t="1782717515325" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7773" width="18" height="18">
			  	<path fill="#8B7355" d="M259.64544 457.44128l504.7296 0c20.35712 0 38.44096 8.2944 51.99872 21.83168 13.57824 13.57824 21.83168 31.66208 21.83168 52.0192l0 342.75328c0 19.5584-8.25344 38.42048-21.83168 51.97824l0 0c-13.55776 12.8-31.6416 21.07392-51.99872 21.07392L259.64544 947.0976c-20.33664 0-39.19872-8.27392-51.99872-21.07392-13.57824-13.55776-21.83168-31.66208-21.83168-51.97824L185.81504 531.29216c0-20.35712 8.27392-38.44096 21.83168-52.0192l0 0 0 0C221.20448 465.75616 239.3088 457.44128 259.64544 457.44128L259.64544 457.44128zM764.35456 497.39776 259.64544 497.39776c-9.80992 0-18.08384 3.72736-24.12544 9.76896l0 0c-6.02112 6.0416-9.78944 15.09376-9.78944 24.14592l0 342.75328c0 9.0112 3.76832 17.32608 9.78944 23.36768 6.0416 6.02112 15.07328 9.78944 24.12544 9.78944l504.7296 0c9.05216 0 17.36704-3.76832 24.12544-9.78944l0 0c6.06208-6.0416 9.80992-14.336 9.80992-23.36768L798.3104 531.29216c0-9.03168-3.76832-18.10432-9.80992-24.14592C781.7216 501.12512 773.4272 497.39776 764.35456 497.39776L764.35456 497.39776z" p-id="7774"></path>
			  	<path fill="#8B7355" d="M753.07008 351.21152c0 10.5472-9.05216 19.59936-20.35712 19.59936-11.28448 0-19.53792-9.05216-19.53792-19.59936 0-55.74656-22.60992-106.20928-58.75712-142.37696-36.94592-36.1472-86.67136-58.75712-142.39744-58.75712-55.76704 0-106.22976 22.60992-142.39744 58.75712-36.16768 36.16768-58.75712 86.6304-58.75712 142.37696l0 118.272c0 10.5472-9.05216 19.59936-19.59936 19.59936-11.28448 0-20.33664-9.03168-20.33664-19.59936l0-118.272c0-66.29376 27.11552-126.5664 70.79936-170.25024 43.7248-43.68384 103.97696-70.81984 170.2912-70.81984 66.29376 0 126.5664 27.11552 170.27072 70.81984C725.95456 224.6656 753.07008 284.93824 753.07008 351.21152L753.07008 351.21152z" p-id="7775"></path>
			  </svg>
            </div>
            <span class="menu-label">修改密码</span>
            <nut-icon name="right" size="14" color="#ccc"></nut-icon>
          </div>
		  <div class="menu-item" @click="handleNavigate('help')">
		    <div class="menu-icon-box icon-help">
		      <nut-icon name="ask" size="17" color="#8B7355"></nut-icon>
		    </div>
		    <span class="menu-label">帮助中心</span>
		    <nut-icon name="right" size="14" color="#ccc"></nut-icon>
		  </div>
		  <div class="menu-item" @click="handleNavigate('about')">
		    <div class="menu-icon-box icon-about">
		      <nut-icon name="tips" size="17" color="#666"></nut-icon>
		    </div>
		    <span class="menu-label">关于我们</span>
		    <span class="menu-extra">v1.0.0</span>
		    <nut-icon name="right" size="14" color="#ccc"></nut-icon>
		  </div>
        </div>
      </div>
      <!-- 退出登录 -->
      <button class="logout-btn" @click="handleLogout">
        <nut-icon name="power" size="18" color="#e87373"></nut-icon>
        <span>退出登录</span>
      </button>

      <!-- 底部留白 -->
      <div class="footer-safe"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Toast } from '@nutui/nutui';

const router = useRouter();

const activeTab = ref(2);

const userName = ref('刘晓庆');
const userDept = ref('产品推广部');
const userAvatar = ref('https://img12.360buyimg.com/imagetools/jfs/t1/196430/38/8105/14329/60c806a4Ed506298a/e6de9fb7b8490f38.png');

const stats = ref({
  orders: 0,
  monthOrders: 0,
  totalAmount: '¥0',
});

// 菜单操作
const handleNavigate = (type) => {
  if (type === 'password') {
    router.push('/password');
    return;
  }
  const map = {
    security: '安全设置',
    help: '帮助中心',
    about: '关于我们',
  };
  Toast.text(map[type] || type);
};


// 退出登录
const handleLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('rememberInfo');
  router.push('/login');
};

// 初始化
onMounted(() => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      userName.value = user.nickName || user.userName || '刘晓庆';
      userDept.value = user.deptName || user.dept?.deptName || '产品推广部';
      if (user.avatar) userAvatar.value = user.avatar;
    }
  } catch (e) {
    // ignore
  }
});
</script>

<style scoped>
/* ========== 页面整体 ========== */
.mine-page {
  min-height: 100vh;
  background: #f5f3f0;
  display: flex;
  flex-direction: column;
}

/* ========== 头部区域 ========== */
.header-section {
  background: linear-gradient(160deg, #3a3226 0%, #4a3f32 30%, #5c4e3d 70%, #4a3f32 100%);
  padding: 0 20px 36px;
  position: relative;
  overflow: hidden;
}
/* 装饰光晕 */
.header-section::before {
  content: '';
  position: absolute;
  top: -40px;
  right: -20px;
  width: 160px;
  height: 160px;
  background: rgba(197, 164, 126, 0.08);
  border-radius: 50%;
  pointer-events: none;
}
.header-section::after {
  content: '';
  position: absolute;
  bottom: 60px;
  left: -30px;
  width: 100px;
  height: 100px;
  background: rgba(197, 164, 126, 0.05);
  border-radius: 50%;
  pointer-events: none;
}

/* 标题栏 */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 8px;
  position: relative;
  z-index: 2;
}
.header-title {
  font-size: 17px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 1px;
}

/* 用户信息 */
.profile-area {
  text-align: center;
  padding: 10px 0 20px;
  position: relative;
  z-index: 2;
}
.avatar-big {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
}
.avatar-border {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  padding: 3px;
  background: linear-gradient(135deg, #C5A47E, #8B7355);
}
.avatar-border img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #4a3f32;
}
.avatar-badge {
  position: absolute;
  bottom: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  background: #C5A47E;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #4a3f32;
}
.profile-name {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px;
  letter-spacing: 1px;
}
.profile-role {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

/* 统计数据 */
.stats-row {
  display: flex;
  justify-content: space-around;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 16px 8px;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;
}
.stats-item {
  text-align: center;
  flex: 1;
}
.stats-num {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 3px;
}
.stats-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
}

/* ========== 内容区域 ========== */
.content-section {
  flex: 1;
  margin-top: -14px;
  border-radius: 24px 24px 0 0;
  background: #f5f3f0;
  padding: 20px 16px 0;
  position: relative;
  z-index: 10;
}

/* 分组 */
.section-group {
  margin-bottom: 16px;
}
.section-title {
  font-size: 13px;
  color: #b5b0a8;
  margin-bottom: 8px;
  padding-left: 6px;
  letter-spacing: 0.5px;
}

/* 菜单卡片 */
.menu-card {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}
.menu-item {
  display: flex;
  align-items: center;
  padding: 15px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f5f3f0;
}
.menu-item:last-child {
  border-bottom: none;
}
.menu-item:active {
  background: #fafaf8;
}
.menu-icon-box {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.icon-eye {
  background: #f5f0e8;
}
.icon-shield {
  background: #edf5ee;
}
.icon-help {
  background: #f5f0e8;
}
.icon-about {
  background: #f5f3f0;
}
.icon-cache {
  background: #f5f3f0;
}
.menu-label {
  flex: 1;
  font-size: 15px;
  color: #3a3226;
  font-weight: 500;
  text-align: left;
}
.menu-extra {
  font-size: 12px;
  color: #ccc;
  margin-right: 6px;
}

/* ========== 退出登录按钮 ========== */
.logout-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #fff;
  color: #e87373;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  letter-spacing: 2px;
}
.logout-btn:active {
  background: #fff5f5;
  transform: scale(0.98);
}

/* ========== 底部安全区 ========== */
.footer-safe {
  height: 80px;
}
</style>
